import Vue from 'vue'
// 引用fontawesome 5的图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlayCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'
import ElSchemaForm from 'el-schema-form'
import 'el-schema-form/dist/el-schema-form.css'

import waves from '@/directive/waves' // 水波纹指令
import elDragDialog from '@/directive/el-dragDialog' // dialog dray
import cut from '@/directive/cut-ipt' // 自动截取文字，兼容input/textarea
import lazyImg from '@/components/LazyImg' // 懒加载
import elCascaderMulti from 'el-cascader-multi' // 树形select组件
import DynamicForm from '@/components/DynamicForm' // 动态表单组件
import Fragment from '@/components/Fragment' // 空标签组件
import PermissionManager from './plugins/permission-manager' // 权限管理组件

import App from './App'
import router from './router'
import store from './store'
import { NODE_ENV } from '@com/config/env'

import i18n from './lang' // Internationalization
import '@/icons' // icon
import '@/permission' // permission control

import imageNotFound from '@/assets/common/404.jpg'
import spinner from '@/assets/common/spinner.svg'

import * as filters from './filters' // global filters

import ECharts from 'vue-echarts' // 在 webpack 环境下指向 components/ECharts.vue
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/dataZoom'

// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
Vue.use(elCascaderMulti)
Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value),
})
Vue.use(VueLazyload, {
  error: imageNotFound,
  loading: spinner,
})
Vue.use(PermissionManager)
Vue.use(ElSchemaForm)

Vue.component('DynamicForm', DynamicForm)
Vue.component('Fragment', Fragment)
Vue.component('lazy-img', lazyImg)
Vue.directive('waves', waves)
Vue.directive('elDragDialog', elDragDialog)
Vue.directive('cut', cut)

Vue.component('v-chart', ECharts)

// mock
// if (NODE_ENV === 'development') {
//   const mock = require('./mock') // eslint-disable-line
// }

/* eslint-disable */
// 无法捕捉到异步错误
if (NODE_ENV === 'production') {
  Vue.config.errorHandler = function (err, vm, info) {
    console.error(`Error in ${info}: `, err, '\r\n 发生错误的 Vue 实例：', vm)
  }
}

/* eslint-enable */

Vue.config.productionTip = false

// eslint-disable-next-line
  new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
})

import '@pt/utils/dom-active'
